import {TooltipContainerDefaultBox} from "./tooltip-container.default";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {TooltipContainerMrGreenBox} from "./tooltip-container.mrgreen";

export const TooltipContainerBox = styledByTheme(TooltipContainerDefaultBox)
    .forMrGreen(TooltipContainerMrGreenBox)
    .apply();